(function () {
  function initCollectionSlider() {
    document.querySelectorAll('.js-flickity').forEach((elem) => {
        const existing = Flickity.data(elem);
        if (existing) {
            existing.destroy();
        }
        const isMobileTablet = window.innerWidth <= 1024;
        new Flickity(elem, {
            cellAlign: 'left',
            contain: true,
            resize: true,
            wrapAround: false,
            prevNextButtons: !isMobileTablet,
            pageDots: false,
            draggable: isMobileTablet,
            selectedAttraction: 0.015,
            friction: 0.25,
            accessibility: false
        });
    });
  }

  // Run immediately
  initCollectionSlider();

  // Theme editor
  document.addEventListener('shopify:section:load', initCollectionSlider);
})();